import { createContext } from 'react';

const OHCContext = createContext<any | null>(null);

export default OHCContext;
